<template lang="pug">
div
  announcement
  .container
    .promotion-wrapper 
      .filter-promotion 
        .filter-content
          .grid
            .row
              template(v-for="promo in promoList")
                .col-12.col-lg-6.grid-item.mix.filter-rebate
                  .promotion-single(@click="deposit")
                    .promotion-single-top
                      .promotion-banner
                        .promo-text
                          h1 {{ promo.promotion_name }}
                          .promo-details.d-flex.justify-content-between
                            .promo-col
                              .promo-title {{ $t("ui.bonus") }}
                              .promo-value {{ promo.bonus_rate }}
                            .promo-col
                              .promo-title {{ $t("ui.min_deposit") }}
                              .promo-value {{ promo.min_deposit }}
                            .promo-col
                              .promo-title {{ $t("ui.rollover") }}
                              .promo-value {{ promo.rollover }}
                            .promo-col
                              .promo-title {{ $t("ui.criteria") }}
                              .promo-value {{ promo.criteria }}
                        img.img-fluid(src='images/promotion/promo01.jpg')

</template>
  
<script>
export default {
  components: {
    announcement: () => import("@/components/_announcement")
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      promoList: [],
    }
  },
  validations: { },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    balance() {
      return this.$store.getters.balance
    }, 
  },
  mounted() {
    this.getPromo()
   },
  methods:{
    getPromo(){
      if (this.isLoggedIn) {
        let login_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getPromo", { login_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.promoList = response.data.promo
            } else {
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info")
            }
          })
          .catch(response => {
            this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info")
          });
      }
    },
    deposit() {
      this.$router.push("/deposit")
    },
    resetForm1() {
      this.feedback.success = true
      this.feedback.status = ""
      this.$v.$reset()
    }
  }
}
</script>